const formWrappers = document.querySelectorAll('.kentico-form-widget-form');

if (formWrappers.length) {
    const formObserver = new MutationObserver((mutations) => {
        let formWrapper;
        mutations.forEach((mutation) => {
            const added = mutation.addedNodes;

            added.forEach((addedElement) => {
                if (
                    addedElement.classList &&
                    addedElement.classList.contains('kentico-form-widget-form')
                ) {
                    formWrapper = addedElement;
                }
            });
        });

        AddMarkupToFormFields(formWrapper, true);
    });

    [].forEach.call(formWrappers, (formWrapper) => {
        const formParent = formWrapper.parentElement;
        formObserver.observe(formParent, { childList: true });
    });
}

function AddMarkupToFormFields(formWrapper, addValidationClasses = false) {
    const formFields = formWrapper
        ? formWrapper.querySelectorAll('.form-field')
        : document.querySelectorAll('.form-field');

    if (!addValidationClasses) {
        return;
    }

    formFields.forEach((formField) => {
        modifyFormField(formField);
    });
}

function modifyFormField(formField) {
    if (!formField.querySelector('label')) {
        return;
    }

    AddValidationClass(formField);
}

function formElementHasError(formField, formElement) {
    const formElementHasError = formElement.classList.contains('input-validation-error');

    const nestedControl = formField.querySelector('.editing-form-control-nested-control');
    const nestedControlHasError =
        nestedControl && Boolean(nestedControl.querySelector('.field-validation-error'));

    return formElementHasError || nestedControlHasError;
}

function AddValidationClass(formField) {
    const formElement = formField.querySelector('input, textarea, select');
    if (!formElement) return;

    if (formElementHasError(formField, formElement)) {
        formField.classList.add('form-field-invalid');
        return;
    }

    formField.classList.add('form-field-valid');
}

AddMarkupToFormFields();
